"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _SM = _interopRequireDefault(require("../Icons/Check/SM"));
var _tss = require("../styles/tss");
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
const _excluded = ["color", "checked", "outlined", "classes", "shape", "className"];
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsCheckboxIcon',
  uniqId: 'hQFMDv'
})((theme, _params, classes) => {
  const {
    colors,
    spacing,
    styles
  } = theme.busbud;
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: spacing(3),
      height: spacing(3)
    },
    shape: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      border: `2px solid ${colors.border.primary.opaque}`,
      backgroundColor: colors.background.primary.opaque,
      [`&.${classes.square}`]: {
        width: spacing(2.25),
        height: spacing(2.25),
        borderRadius: styles.rounding.sm
      },
      [`&.${classes.circle}`]: {
        width: spacing(2.5),
        height: spacing(2.5),
        borderRadius: styles.rounding.circle
      },
      // when `outlined` is enabled, the `color` is ignored (by design)
      [`.${classes.checked}:not(.${classes.outlined}) &`]: {
        borderWidth: 0
      },
      [`.${classes.colorPrimary}:not(.${classes.outlined}) &`]: {
        backgroundColor: colors.component.switch.active.primary.foreground
      },
      [`.${classes.colorSecondary}:not(.${classes.outlined}) &`]: {
        backgroundColor: colors.component.switch.active.secondary.foreground
      }
    },
    icon: {
      position: 'relative'
    },
    square: {},
    circle: {},
    checked: {},
    outlined: {},
    colorPrimary: {},
    colorSecondary: {}
  };
});
const getColorClass = color => `color${(0, _capitalizeFirstWord.capitalizeFirstWord)(color)}`;
const CheckboxIcon = /*#__PURE__*/_react.default.forwardRef(function CheckboxIcon(_ref, ref) {
  let {
      color,
      checked,
      outlined,
      classes: classesOverrides,
      shape,
      className
    } = _ref,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    classes,
    cx
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const iconColor = outlined ? 'text.primary.opaque' : 'text.overBackground.opaque';
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: cx(className, classes.root, {
      [classes.checked]: checked,
      [classes.outlined]: outlined,
      [classes[getColorClass(color)]]: checked
    })
  }, other, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: cx(classes.shape, classes[shape])
  }), checked && /*#__PURE__*/_react.default.createElement(_SM.default, {
    className: classes.icon,
    color: iconColor
  }));
});
var _default = exports.default = CheckboxIcon;